import React from 'react';
export function MinervaLogo({
  className = ''
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/f6rhZmNVQToPzaCpFUg82w/Screenshot_2026-05-12_at_11.27.12.png" alt="Minerva Imaging" className={`h-8 w-auto object-contain ${className}`} data-id="element-35" />;
}